import {TemplateConfig} from '../types';

export const classicConfig: TemplateConfig = {
  id: 'classic',
  name: 'templates.classic.name',
  description: 'templates.classic.description',
};

export default classicConfig;
